import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { UserIdentityConflictContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getNoDefaultFilters } from '../../contentDefinitions/getDefaultFilters';
import { UserIdentityConflicts } from '../services/resources/UserIdentityConflicts';

export const UserIdentityConflictDefinition: ExplorableItemDefinition = {
  itemType: 'userIdentityConflict',
  singularName: () => Messages.identityMigration_ConflictsSingularName(),
  pluralName: () => Messages.identityMigration_ConflictsPluralName(),
  emptyStateMessage: () => Messages.identityMigration_ConflictsEmptyStateMessage(),
  contentFilterKeys: UserIdentityConflictContentType.filterKeys,
  filterClause: ServerFilterClauses.ContentType(['userIdentityConflict']) as ContentTypeFilterClause,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconUrl: null,
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    return UserIdentityConflicts.all();
  },
};
